const filterLabelRow = "flex items-center gap-1.5";

const dateInputWrapper = "flex flex-wrap gap-2 mt-1.5";

const clearAllBtn = "inline-flex items-center gap-1 text-xs font-medium text-muted-foreground hover:text-destructive transition-colors";

const cursorPointer = "cursor-pointer";

export { filterLabelRow, dateInputWrapper, clearAllBtn, cursorPointer };
